
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"34","viewBox":"0 0 41 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.04 4.598a17.097 17.097 0 01-4.726 1.295 8.154 8.154 0 003.608-4.533 16.388 16.388 0 01-5.2 1.985A8.217 8.217 0 0027.732.75c-4.54 0-8.195 3.685-8.195 8.203 0 .65.055 1.274.19 1.87-6.818-.333-12.85-3.6-16.903-8.578A8.256 8.256 0 001.702 6.39a8.212 8.212 0 003.642 6.815 8.098 8.098 0 01-3.705-1.01v.09c0 3.985 2.843 7.295 6.57 8.058a8.185 8.185 0 01-2.15.27c-.525 0-1.055-.03-1.552-.14 1.062 3.247 4.077 5.635 7.662 5.712a16.477 16.477 0 01-10.167 3.498c-.673 0-1.318-.03-1.963-.113 3.633 2.343 7.938 3.68 12.58 3.68 15.09 0 23.34-12.5 23.34-23.335 0-.362-.012-.712-.03-1.06 1.628-1.155 2.995-2.598 4.11-4.258z"}})])
          )
        }
      }
    